var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9753 7.19517C19.6631 7.08253 19.3187 7.24667 19.2093 7.55885L18.7459 8.85906C18.202 7.63287 17.3427 6.55472 16.2484 5.74691C12.7694 3.17223 7.81311 3.87383 5.20624 7.31747C3.94465 8.98458 3.4104 11.0379 3.70649 13.0976C4.00258 15.167 5.10004 16.9983 6.78967 18.2502C8.20575 19.2962 9.8632 19.8047 11.5078 19.8047C13.9119 19.8047 16.2838 18.7265 17.8319 16.6829C18.5174 15.7785 18.984 14.768 19.2254 13.6737C19.2962 13.3487 19.0902 13.0301 18.7684 12.9592C18.4466 12.8884 18.1247 13.0912 18.0539 13.4163C17.8512 14.3399 17.4553 15.196 16.876 15.9588C14.665 18.8778 10.4586 19.4732 7.50415 17.2847C6.07198 16.2259 5.14509 14.6779 4.89406 12.9271C4.64303 11.1859 5.0936 9.45124 6.16209 8.0416C8.36989 5.12255 12.5731 4.52394 15.5307 6.71242C16.6024 7.50414 17.4038 8.6016 17.8383 9.84066L15.7753 9.03607C15.4664 8.91699 15.1188 9.06826 14.9965 9.37722C14.8742 9.68618 15.0287 10.0338 15.3376 10.1561L18.3758 11.3436C18.4466 11.3726 18.5206 11.3855 18.5946 11.3855C18.6043 11.3855 18.6139 11.3823 18.6236 11.3823C18.6461 11.3855 18.6686 11.3951 18.6912 11.3951C18.939 11.3951 19.1707 11.2406 19.2576 10.9961L20.339 7.9708C20.4484 7.65218 20.2875 7.30782 19.9753 7.19517Z",
    fill: "#2469EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.7539061a62de47797687e034096fd5f6.svg";
export { ForwardRef as ReactComponent };